export default __webpack_public_path__ + "static/media/icon-instagram.7243a75e.svg";